<template>

  <div class="grid grid-cols-6 bg-grey gap-4 p-5" id="create-rule-container-form">
    <div class="font-bold">
      <vs-input
          placeholder="Nombre del indicador"
          v-model="form.name"
          name="ruleName"
          :danger="errors.has('ruleName')"
          :danger-text="errors.first('ruleName')"
          data-vv-validate-on="blur"
          v-validate="'required'"></vs-input>
    </div>
    <div>
      <vs-input
          placeholder="Slug del indicador"
          name="identityName"
          :danger="errors.has('identityName')"
          :danger-text="errors.first('identityName')"
          data-vv-validate-on="blur"
          v-validate="'required'"
          v-model="form.identity_name"></vs-input>
    </div>
    <div>
      <vs-input
          placeholder="Peso del indicador"
          name="weight"
          :danger="errors.has('weight')"
          :danger-text="errors.first('weight')"
          data-vv-validate-on="blur"
          v-validate="'required'"
          v-model="form.weight"></vs-input>
    </div>
    <div>
      <vs-select
          placeholder="Tipo de análisis"
          name="analysisType"
          :danger="errors.has('analysisType')"
          :danger-text="errors.first('analysisType')"
          data-vv-validate-on="blur"
          v-validate="'required'"
          v-model="form.analysis_type.type" class="w-full">
        <vs-select-item
            v-for="(analysisType, idx) in analysisTypes"
            :key="idx"
            :value="analysisType.value"
            :text="analysisType.name"></vs-select-item>
      </vs-select>
      <vs-select
          v-model="form.analysis_type.argument"
          v-if="form.analysis_type.type === 'Catalog'"
          class="w-full mt-2"
          v-validate="'required'"
      >
        <vs-select-item
            v-for="catalog in catalogs"
            :text="catalog.category"
            :value="catalog.category"></vs-select-item>
      </vs-select>
    </div>
    <div>
      <vs-input
          placeholder="Límite inferior"
          v-validate="'required'"
          name="worstValue"
          :danger="errors.has('worstValue')"
          :danger-text="errors.first('worstValue')"
          data-vv-validate-on="blur"
          v-model="form.worst_value"></vs-input>
    </div>
    <div class="flex">
      <vs-input
          placeholder="Límite superior"
          v-validate="'required'"
          name="bestValue"
          :danger="errors.has('bestValue')"
          :danger-text="errors.first('bestValue')"
          data-vv-validate-on="blur"
          v-model="form.best_value"></vs-input>

      <vs-button
          @click="addItem"
          class="ml-1" icon="add"></vs-button>
    </div>
  </div>

</template>
<script>
export default {
  name: "RiskModelRuleForm",
  props: {
    analysisTypes: {
      type: Array,
      default: () => ([])
    },
    catalogs: {
      type: Array,
      required: true,
      default: () => []
    },
  },
  data: () => ({
    form: {
      name: '',
      identity_name: '',
      weight: 0,
      analysis_type: {
        value: 0,
        name: ''
      },
      worst_value: 0,
      best_value: 0
    },
  }),
  methods: {
    async addItem() {
      if (await this.$validator.validate()) {
        this.resetForm()
        this.$emit('onAddItem', Object.assign({}, this.form))
      }
    },
    resetForm() {
      this.form.name = '';
      this.form.identity_name = '';
      this.form.weight = 0;
      this.form.analysis_type = {
        value: 0,
        name: ''
      };
      this.form.worst_value = 0;
      this.form.best_value = 0;
    }
  }
}
</script>
<style scoped>

</style>